import { Box } from "@mui/material";
import classNames from "classnames/bind";
import styles from "./BaseTabMenu.module.scss";

type TabItem = {
  id: string;
  label: string;
  count: number;
};

type BaseTabMenuProps = {
  tabs?: TabItem[];
  activeTab?: string;
  onTabChange?: (tabId: string) => void;
};

const cx = classNames.bind(styles);

const defaultTabs: TabItem[] = [
  { id: "sales", label: "Sales", count: 0 },
  { id: "production", label: "Production", count: 0 },
  { id: "billing", label: "Billing", count: 0 },
];

const BaseTabMenu = ({
  tabs = defaultTabs,
  activeTab = "sales",
  onTabChange,
}: BaseTabMenuProps) => {
  const handleTabClick = (tabId: string) => {
    if (onTabChange) {
      onTabChange(tabId);
    }
  };

  return (
    <Box className={cx("tab-menu-container")}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={cx("tab-item", { active: activeTab === tab.id })}
          onClick={() => handleTabClick(tab.id)}
        >
          <span className={cx("tab-label")}>{tab.label}</span>
          <span className={cx("tab-count")}>({tab.count})</span>
        </button>
      ))}
    </Box>
  );
};

export default BaseTabMenu;
